import { render, staticRenderFns } from "./OtherCompanyConstructionEditPage.vue?vue&type=template&id=ea94d398&"
import script from "./OtherCompanyConstructionEditPage.vue?vue&type=script&lang=ts&"
export * from "./OtherCompanyConstructionEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports